// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { columnsStyles } from "@sc/Overrides/Widgets/ProductList/ProductListColumns";
import Close from "@sc/XDL/Icons/Close";
import { buttonTransparent } from "@sc/XDL/PreStyle/button";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

columnsStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 376px calc(100% - 398px); // 398px = 376px + 22px gap
        grid-column-gap: 22px;
        ${xScreen("lte", "lg")} {
            grid-template-columns: 317px calc(100% - 339px); // 339px = 317px + 22px gap
        }
    `,
};

columnsStyles.leftColumnGridItem = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

columnsStyles.rightColumnGridItem = {
    css: css`
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
    `,
};

columnsStyles.filtersDrawer = {
    headlineTypographyProps: {
        forwardAs: "p",
        size: 16,
        weight: fontConfig.weight.bold,
        color: "text",
        lineHeight: "22px",
    },
    closeButtonIconProps: {
        src: Close,
        size: 12,
        css: css`
            &&&& {
                color: ${getColor("primary")};
            }
        `,
    },
    cssOverrides: {
        scrim: css`
            ${xScreen("lte", "md")} {
                top: 0;
            }
        `,
        drawerTitle: css`
            background: ${color("common.white")};
            padding: 16px 0 8px;
            margin: 0 16px;
            border-bottom: 1px solid ${color("common.border")};
            button {
                padding: 0;
            }
        `,
        headlineTypography: css`
            margin: 0;
        `,
        titleButton: css`
            ${buttonTransparent}
            padding: 8px 0 8px 8px;
            ${IconWrapper} {
                color: ${color("text.main")};
            }
        `,

        drawerBody: css`
            width: 360px;
            background-color: ${color("common.white")};
            ${xScreen("lte", "sm")} {
                top: 0;
                height: 100%;
                width: 100%;
            }
        `,
        drawerContent: css`
            overflow-x: hidden;
            padding: 16px;
            margin-bottom: 54px;
            background: ${color("common.white")};
        `,
    },
};

columnsStyles.controlsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        gap: 16px;
        & div {
            max-width: 100%;
            width: 100%;
        }
        & div[data-test-selector="productList_pagination"] {
            margin: 0;
            ${FormFieldStyle} {
                gap: 8px;
                label {
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 13px;
                    min-height: unset;
                }
            }
        }
    `,
};
